import type { ResponsiveImageUrls } from "./types";

interface PictureVariantProps {
  imageData: ResponsiveImageUrls;
  fill?: boolean;
  className?: string;
  objectFit?: string;
  objectPosition?: string;
  breakpoints?: {
    mobile?: string;
    tablet?: string;
    desktop?: string;
  };
  [key: string]: any;
}

const DEFAULT_BREAKPOINTS = {
  mobile: "(max-width: 768px)",
  tablet: "(min-width: 769px) and (max-width: 1023px)",
  desktop: "(min-width: 1024px)",
};

export function PictureVariant({
  imageData,
  fill,
  className,
  objectFit = "cover",
  objectPosition,
  breakpoints,
  ...props
}: PictureVariantProps) {
  const bp = { ...DEFAULT_BREAKPOINTS, ...breakpoints };

  const style: React.CSSProperties = {
    objectFit: objectFit as any,
    objectPosition,
    // When fill is true, the img needs absolute positioning to fill the picture element
    ...(fill && {
      position: "absolute",
      width: "100%",
      height: "100%",
      inset: 0,
    }),
  };

  const pictureClassName = fill ? "absolute inset-0" : className;

  return (
    <picture className={pictureClassName}>
      {imageData.desktop && <source media={bp.desktop} srcSet={imageData.desktop} />}
      {imageData.tablet && <source media={bp.tablet} srcSet={imageData.tablet} />}
      {imageData.mobile && <source media={bp.mobile} srcSet={imageData.mobile} />}
      <img
        src={imageData.fallback || ""}
        alt={imageData.alt}
        className={className}
        style={style}
        {...props}
      />
    </picture>
  );
}
